import './DatePicker.scss';

export const DatePicker = ({ question, description, onDateChange, date }) => {
  return (
    <div className="date-picker">
      <div className="question">{question}</div>
      <div className="input">
        <input type="date" value={date} onChange={(e) => onDateChange(e.target.value)} />
        <div className="description">{description}</div>
      </div>
    </div>
  );
};
